module.exports = __webpack_public_path__ + "media/fonts/IntroBold-575ebff4.ttf";